import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './settingPopover.module.scss';
import './styles.scss';
import { PrintQR } from 'components/Cards';
import CloseIcon from 'assets/img/close3.png'
import { useStore } from 'store';
import { useHistory } from 'react-router-dom'
import RegaloIcon from 'assets/img/iconregalo.svg';
import CelIcon from 'assets/img/cel.png';
import MsgIcon from 'assets/img/msg.png';

const SettingPopoverMovi = ({ show, setShow, onlyLadingGuest }) => {
    const [subMenuOpen, setSubMenuOpen] = useState(false); // Añadimos estado para controlar la apertura del submenú
    const [currentGiftTable] = useStore(
        (state) => state.giftTable.giftTable
    );
    const history = useHistory()

    const handleSubMenuClick = () => {
        setSubMenuOpen(!subMenuOpen);
    };

    const [getOpenModal, setOpenModal] = useState(false);

    const handleClickShare = () => {
        setOpenModal(true);
        setShow(false)
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <nav className={styles['side-bar']} data-open={show}>
            <div className={styles['header-side-bar-container']}>
                <span className={styles.title}>Mesa de Regalos SEARS</span>
                <button className={styles['close-button']} onClick={() => setShow(false)}>
                    <img src={CloseIcon} className={styles['close-icon']} />
                </button>
            </div>
            {
                !onlyLadingGuest && (
                    <>
                        <section className={styles['section-side-bar-container']}>
                            <div className={styles['title-and-icon']}>
                                <img src={RegaloIcon} alt="regaloicon" height="20" />
                                <span className={styles['title-or-link']}>Evento #{currentGiftTable.evento}</span>
                            </div>
                            <div className={styles['links-container']}>
                                <span className={styles['label-or-link']} onClick={() => handleSubMenuClick()} data-active={subMenuOpen} >
                                    Mi mesa
                                    {
                                        subMenuOpen && (
                                            <div className={styles['menu-links-container']}>
                                                <Link to='/my-info' className={styles['submenu-link']}>Datos generales</Link>
                                                {/*<Link to={'#'} className={styles['submenu-link']}>Mi cupón</Link>*/}
                                            </div>
                                        )
                                    }
                                </span>
                                <Link className={styles['label-or-link']} to='/agregar-regalos'>
                                    Agregar regalos
                                </Link>
                                <Link className={styles['label-or-link']} to='/regalos-recibidos' >
                                    Regalos recibidos
                                </Link>
                                <Link className={styles['label-or-link']} to='/compartir-mesa'>
                                    Compartir mi mesa
                                </Link>
                                <Link className={styles['label-or-link']} to='/rsvp'>
                                    Mis invitados
                                </Link>
                            </div>
                        </section>
                        <div className={styles['hr-container']}>
                            <hr className={styles.hr} />
                        </div>
                        <section className={styles['section-side-bar-container']}>
                            <div className={styles['title-and-icon']}>
                                <img src={CelIcon} alt="celicon" height="26" />
                                <span className={styles['title-or-link']}>Mis mesas</span>
                            </div>
                            <div className={styles['links-container']}>
                                <Link className={styles['label-or-link']} to='/mis-mesas'>
                                    Buscar evento
                                </Link>
                            </div>
                        </section>
                        <div className={styles['hr-container']}>
                            <hr className={styles.hr} />
                        </div>
                    </>
                )
            }
            {
                onlyLadingGuest && <Button className={styles.button} onClick={() => history.push('/crear-mesa')}>Crear mesa</Button>
            }
            <section className={styles['section-side-bar-container']}>
                <div className={styles['title-and-icon']}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="1.2em"
                        viewBox="0 0 512 512"
                    >
                        <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
                    </svg>
                    <Link className={styles['title-or-link']} to='/faqs'>Preguntas Frecuentes</Link>
                </div>
            </section>
            <div className={styles['hr-container']}>
                <hr className={styles.hr} />
            </div>
            <section className={styles['section-side-bar-container']}>
                <div className={styles['title-and-icon']}>
                    <img src={MsgIcon} alt="msgicon" height="20" />
                    <Link className={styles['title-or-link']} to='/review'>Reseñas</Link>
                </div>
            </section>
            {
                !onlyLadingGuest && <Button className={styles.button} onClick={() => history.push('/crear-mesa')}>Crear mesa</Button>
            }
            <PrintQR variant="none" getOpenModal={getOpenModal} closeModal={handleCloseModal} />
        </nav>

    )
}

export default SettingPopoverMovi;
